import React from 'react';
import { HeaderDescription, Description } from './APIKeysPage.styles';
import useAPIKeys from '../../../hooks/useAPIKeys';
import Skeleton from '@hud/web-components/Skeleton/Skeleton';
import Page from '../Components/SettingsPage';
import { APIKeys } from '../../../components/APIKeys/APIKeys';
import { ContactUsLink } from '../../../components/ContactUsLink/ContactUsLink';

export default function APIKeysPage() {
  const { data, isLoading } = useAPIKeys();

  return (
    <Page className="apiKeys">
      <h2>API Keys</h2>
      <HeaderDescription>
        You need a private key when initializing Hud SDK to securely authenticate your
        service.
      </HeaderDescription>
      {isLoading ? <Skeleton width={300} /> : <APIKeys keys={data?.apiKeys || []} />}
      <Description>
        Need help?{' '}
        <ContactUsLink startConversationContent="Hi! I need another API Key.">
          Chat with our support team
        </ContactUsLink>{' '}
        or email us at support@hud.io.
      </Description>
    </Page>
  );
}
